import React from "react";

interface CheckBoxProps {
  checked?: boolean;
  onChange: () => void;
  isEnabled?: boolean;
  loading?: boolean; // New loading prop
}

const Checkbox: React.FC<CheckBoxProps> = ({
  checked = false,
  onChange,
  isEnabled = true,
  loading = false, // Default loading state to false
}) => {
  const borderColor = loading
    ? "border-transparent"
    : checked
    ? isEnabled
      ? "border-icon-blue-light"
      : "border-[#B7BBD4]"
    : isEnabled
    ? "border-grayscale-2"
    : "border-[#B7BBD4]";

  const backgroundColor = loading
    ? "bg-[#ECECEC]"
    : isEnabled
    ? "bg-transparent"
    : "bg-transparent";

  const handleClick = () => isEnabled && !loading && onChange();

  return (
    <div
      onClick={handleClick}
      className={`w-[20px] h-[20px] border-[1px] ${borderColor} ${backgroundColor} rounded flex items-center justify-center cursor-${
        isEnabled && !loading ? "pointer" : "not-allowed"
      } transition-opacity duration-300 ${loading ? "animate-pulse" : ""}`}
      style={{ width: "20px", height: "20px" }} // Fixed width and height
    >
      <div className="w-[16px] h-[16px] flex items-center justify-center">
        {!loading && checked && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M13.1562 4.71875L6.59375 11.2812L3.3125 8"
              stroke={isEnabled ? "#3CAEE0" : "#B7BBD4"}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
    </div>
  );
};

export default Checkbox;
